import { IServiceResult } from "../../infrastructure/Interfaces/IServiceResult";
import { SVCEtapasProcesos } from "../../infrastructure/services/api/SVCEtapasProcesos";
// import IViewPanelesAlumno from "../../presentation/view-interfaces/IViewPanelesAlumno";
import IViewParametros from "../../presentation/view-interfaces/IViewParametros";

export const ObtieneEtapaProceso = (selListaEtapaProceso: any,
    rut: number,
    año: number,
    periodo: number,
    codigoNegocio: number,
    codigoPrograma: string,
    codigoPlanificacionAcademica: number
) => {
    let list: Array<IViewParametros> = [];
    SVCEtapasProcesos.ObtieneEtapaProceso(rut, año, periodo, codigoNegocio, codigoPrograma, codigoPlanificacionAcademica).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            //let data: any = res.result;
            /* list.push({
            }); */

            selListaEtapaProceso(false, '', list);
        } else {
            selListaEtapaProceso(true, res.errorDetails, list);
        }
    });

};
export const InsertPrimeraEtapaProceso = (selListaEtapaProceso: any,
    rut: number,
    año: number,
    periodo: number,
    codigoNegocio: number,
    codigoPrograma: string,
    codigoPlanificacionAcademica: number,
    idPeriodo: number
) => {
    let list: Array<IViewParametros> = [];
    SVCEtapasProcesos.InsertPrimeraEtapaProceso(rut, año, periodo, codigoNegocio, codigoPrograma, codigoPlanificacionAcademica, idPeriodo).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            /* console.log(data) */
            /* list.push({
            }); */

            selListaEtapaProceso(false, '', data);
        } else {
            selListaEtapaProceso(true, res.errorDetails, list);
        }
    });

};
export const InsertPrimeraEtapaProcesoFirma = (selListaEtapaProceso: any,
    rut: number,
    año: number,
    periodo: number,
    codigoNegocio: number,
    codigoPrograma: string,
    codigoPlanificacionAcademica: number
) => {
    let list: Array<IViewParametros> = [];
    SVCEtapasProcesos.InsertPrimeraEtapaProcesoFirma(rut, año, periodo, codigoNegocio, codigoPrograma, codigoPlanificacionAcademica).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            /* console.log(data) */
            /* list.push({
            }); */

            selListaEtapaProceso(false, '', data);
        } else {
            selListaEtapaProceso(true, res.errorDetails, list);
        }
    });

};
export const UpdateEtapaProceso = (selListaUpdateProceso: any,
    idProceso: number, idEtapa: number, esPregradoSinRF: boolean
) => {
    let list: Array<IViewParametros> = [];
    SVCEtapasProcesos.UpdateEtapaProceso(idProceso, idEtapa,esPregradoSinRF).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            /* list.push({
            }); */

            selListaUpdateProceso(false, '', data);
        } else {
            selListaUpdateProceso(true, res.errorDetails, list);
        }
    });

};

export const ObtieneSiguienteEtapa = (selListaEtapaProceso: any,
    contrato: boolean, pago: boolean
) => {
    let list: any = [];
    SVCEtapasProcesos.ObtieneSiguienteEtapa(contrato, pago).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            /* list.push({
            }); */

            selListaEtapaProceso(false, '', data);
        } else {
            selListaEtapaProceso(true, res.errorDetails, list);
        }
    });

};